import React from 'react'
import PropTypes from 'prop-types'
import PoolCover from 'components/pool_cover'
import { routerShape } from 'react-router/lib/PropTypes'
import { withRouter } from 'react-router'

class PoolCoverCreate extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    router: routerShape.isRequired,
    fields: PropTypes.object.isRequired,
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <PoolCover fields={this.props.fields} />
      </form>
    )
  }
}

export default withRouter(PoolCoverCreate)
